export default {
      id: "city-icon-4-usage",
      viewBox: "0 0 112 80",
      url: __webpack_public_path__ + "sprite.svg#city-icon-4",
      toString: function () {
        return this.url;
      }
    }